import { ref } from 'vue'

type PermissionStatus = 'granted' | 'denied' | 'prompt'

const webcamState = ref<boolean>(false)
const permissions = ref<PermissionStatus>('prompt')

export const useStoreWebcam = () => {
  const toggleWebcam = (status: boolean) => {
    webcamState.value = status
  }

  const setGlobalPermissions = (status: PermissionStatus) => {
    permissions.value = status
  }

  return {
    toggleWebcam,
    setGlobalPermissions,
    webcamState,
    permissions
  }
}
